import { useState } from "react";
import { useAuth } from "@/lib/auth";
import { toast } from "sonner";
import { EyeOff, Eye } from "lucide-react";

// One-tap streamer mode: hides email, DOB and personal info from everyone but you.
export default function StreamerToggle({ compact = false }) {
  const { user, updatePrivacy } = useAuth();
  const [busy, setBusy] = useState(false);
  if (!user) return null;
  const on = !!(user.privacy && user.privacy.streamer_mode);

  const toggle = async () => {
    setBusy(true);
    try {
      await updatePrivacy({ streamer_mode: !on });
      toast.success(!on ? "Streamer mode ON — personal info hidden" : "Streamer mode OFF");
    } catch { toast.error("Could not update"); }
    setBusy(false);
  };

  return (
    <button
      data-testid="streamer-toggle"
      onClick={toggle}
      disabled={busy}
      title={on ? "Streamer mode on" : "Streamer mode off"}
      className={`inline-flex items-center gap-1.5 rounded-full border transition-colors ${compact ? "px-2 py-1.5" : "px-3 py-2"} ${
        on ? "bg-[#FFBF00]/15 border-[#FFBF00]/50 text-[#FFBF00]" : "border-white/10 text-white/60 hover:text-white hover:bg-white/5"
      }`}
    >
      {on ? <EyeOff size={16} /> : <Eye size={16} />}
      {!compact && <span className="text-[10px] uppercase tracking-widest">{on ? "Streamer" : "Streamer"}</span>}
    </button>
  );
}
